import React, { FC } from 'react'
import styled from 'styled-components'
import RoundButton, { Icon } from 'uiComponents/atoms/Buttons/RoundButton'
import { complementaryColor, primaryColor } from 'uiComponents/constants/colors'
import { fsS, fwHeavy } from 'uiComponents/constants/typography'
import arrowGrayDownIcon from 'uiComponents/icons/arrow-gray-down.svg'
import arrowGrayUpIcon from 'uiComponents/icons/arrow-gray-up.svg'
import arrowWhiteDownIcon from 'uiComponents/icons/arrow-white-down.svg'
import arrowWhiteUpIcon from 'uiComponents/icons/arrow-white-up.svg'
import { ControlColor } from 'uiComponents/molecules/Slider/VerticalSlider'

const PaginationState = styled.div<{
  color: 'primary' | 'secondary'
}>`
  font-family: inherit;
  white-space: nowrap;
  font-size: ${fsS}px;
  ${fwHeavy};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${({ color }) =>
    color === 'primary' ? primaryColor : complementaryColor};
  margin-top: 25px;
  margin-bottom: 25px;
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: visible;
`

interface Props {
  color?: ControlColor
  slideCount: number
  currentIndex: number
  limited?: boolean
  next: () => void
  back: () => void
  className?: string
  upAriaLabel?: string
  downAriaLabel?: string
}

const VerticalSliderControl: FC<Props> = ({
  color = 'secondary',
  slideCount,
  currentIndex,
  limited,
  next,
  back,
  className,
  upAriaLabel,
  downAriaLabel,
}) => {
  const backDisabled = limited && currentIndex === 0
  const forwardDisabled = limited && currentIndex >= slideCount - 1

  return (
    <Wrapper data-testid="VerticalSliderControlWrapper" className={className}>
      <RoundButton
        data-testid="ButtonUp"
        aria-label={upAriaLabel}
        disabled={backDisabled}
        onClick={back}
      >
        <Icon
          dropShadow={color === 'secondary'}
          backgroundSrc={
            color === 'primary' ? arrowGrayUpIcon : arrowWhiteUpIcon
          }
        />
      </RoundButton>
      <PaginationState data-testid="VerticalSliderControlValue" color={color}>
        {currentIndex + 1} / {slideCount}
      </PaginationState>
      <RoundButton
        data-testid="ButtonDown"
        aria-label={downAriaLabel}
        disabled={forwardDisabled}
        onClick={next}
      >
        <Icon
          dropShadow={color === 'secondary'}
          backgroundSrc={
            color === 'primary' ? arrowGrayDownIcon : arrowWhiteDownIcon
          }
        />
      </RoundButton>
    </Wrapper>
  )
}

export default VerticalSliderControl
